class ShareWebinar {
    constructor(webinarShareRepo) {
        this.webinarShareRepo = webinarShareRepo;
    }
    async shareWebinarByEmail(payload) {
        return await this.webinarShareRepo.shareWebinarByEmail(payload);
    }
}
export default ShareWebinar;
